export default __webpack_public_path__ + "../static/images/nickname-generator/avatar-2.jpg";